import PropTypes from 'prop-types'

import { formatPriceDecimals } from 'utils/formatPriceDecimals'
import { orderStates } from 'utils/resources'
import { formatTime } from 'utils/formatTime'
import { isDisabledPendingRefundRow } from 'utils/PendingRefunds'

const PendingRefundsDesktop = ({ pedningRefunds, onClickPendingRefund }) => {
  return (
    <div className="items">
      <div className="header">
        <ul className="header__menu">
          <li className="header__menu-item">Date</li>
          <li className="header__menu-item">Order #</li>
          <li className="header__menu-item">Refund Status</li>
          <li className="header__menu-item">Amount</li>
          <li className="header__menu-item">Customer</li>
        </ul>
      </div>
      <section className="item-list section">
        {pedningRefunds?.map((order) => (
          <button
            className="item"
            key={order?.uuid}
            onClick={onClickPendingRefund(order?.uuid)}
            disabled={isDisabledPendingRefundRow(order?.state)}
          >
            <div className="row">
              <div className="item-info-wrapper">
                {formatTime(order?.createdAt, 'MM/DD/YY, h:mm A')}
              </div>
              <div className="item-info-wrapper">
                {order?.submissionResult?.confirmationNumber ?? 'unknown'}
              </div>
              <div className="item-info-wrapper">
                <span
                  className={`item-info-wrapper__dot -dot-${order?.state}`}
                ></span>
                {orderStates[order?.state] ?? 'unknown'}
              </div>
              <div className="item-info-wrapper">{`${formatPriceDecimals(
                order?.total
              )}`}</div>
              <div className="item-info-wrapper">
                {order?.userName ?? 'N/A'}
              </div>
            </div>
          </button>
        ))}
      </section>
    </div>
  )
}

PendingRefundsDesktop.propTypes = {
  pedningRefunds: PropTypes.array,
  onClickPendingRefund: PropTypes.func,
}

export default PendingRefundsDesktop
